import { Image } from "react-bootstrap";

import FLAG_PL from "../assets/flag-pl.png";
import FLAG_GB from "../assets/flag-gb.png";
import { useHistory } from "react-router-dom";

export const LanguageFlag = ({ outsideFlagSetter, flag, i18n }) => {
  const history = useHistory();
  function onClick() {
    outsideFlagSetter(flag === "en" ? "pl" : "en");
    i18n.changeLanguage(flag === "en" ? "pl" : "en", () => {});
    history.replace(flag === "en" ? "pl" : "en");
  }

  return (
    <Image
      onClick={onClick}
      src={flag === "en" ? FLAG_PL : FLAG_GB}
      className="LanguageFlagImage"
    />
  );
};
